export const nameRoutes = {
    home: 'home',
    pharmacists: 'pharmacists',
    companies: 'companies',
    calendar: 'calendar',
    employees: 'employees',
    typologyHours: 'typologyHours',
    closeDays: 'closeDays',
    employeesSituation: 'employeesSituation',
    hoursMany: 'hoursMany',
    stats: 'stats',
    prospect: 'prospect',
}
